<ng-container
  *ngrxLet="{
    manageeSeatOptions: manageeSeatOptions$,
    language: language$,
  } as vm">
  <form [formGroup]="form" id="create-discussion-form">
    <div class="form-row">
      <nty-title formControlName="title" placeholder="Title your {{ vm.language.item }}" />
      @if (hasRequiredError('title') && isSubmitted) {
        <nty-form-error>Give your Discussion a name.</nty-form-error>
      }
    </div>

    <div class="form-row description-row">
      <nty-description
        formControlName="description"
        placeholder="Add a description {{ isOptional(form.controls['description']) ? '(optional)' : '' }}" />
    </div>

    <div class="form-row">
      <ion-text class="ctrl-label terra-body">Manager</ion-text>
      <nty-discussion-participant-select
        formControlName="managerId"
        [userOptions]="(managerUserOptions$ | async) ?? []" />
    </div>

    <div class="form-row">
      <ion-text class="ctrl-label terra-body">Team Member</ion-text>
      <nty-discussion-participant-select
        formControlName="manageeId"
        [error]="hasRequiredError('manageeId') && isSubmitted"
        mode="managee"
        [userOptions]="(manageeUserOptions$ | async) ?? []" />
      @if (hasRequiredError('manageeId') && isSubmitted) {
        <nty-form-error>Choose a participant</nty-form-error>
      }
    </div>

    @if (form.value.manageeId) {
      <div class="form-row">
        <ion-text class="ctrl-label terra-body">Seat</ion-text>
        <nty-discussion-seat-select
          id="managee-seat-selector"
          formControlName="manageeSeatHolderId"
          [seatOptions]="vm.manageeSeatOptions" />
      </div>
    }

    <div class="form-row time-period-row">
      <ion-text class="ctrl-label terra-body">Time period</ion-text>
      <div>
        <nty-date-picker formControlName="periodStartDate" />
      </div>

      <span>to</span>

      <div>
        <nty-date-picker formControlName="periodEndDate" />
      </div>
    </div>

    <div class="form-row">
      <ion-text class="ctrl-label terra-body">Due Date</ion-text>
      <nty-date-picker formControlName="dueDate" [minDate]="minDueDate" [maxDate]="maxDueDate" />
    </div>

    <div class="form-row">
      <ion-accordion-group [multiple]="true">
        <ion-accordion value="first" toggleIcon="assets/icons/caret-down--regular.svg">
          <ion-item slot="header">
            <ion-label>Settings</ion-label>
          </ion-item>
          <div class="ion-padding" slot="content">
            <div class="form-row">
              <ion-checkbox formControlName="canEvaluateSelf" labelPlacement="end">
                <ion-text class="checkbox-heading">Self-Evaluation</ion-text>
                <br />
                <ion-text class="checkbox-desc">I want the Team Member to complete a self-evaluation.</ion-text>
              </ion-checkbox>
            </div>

            <div class="form-row">
              <ion-checkbox formControlName="canEvaluateManager" labelPlacement="end" class="capitalize">
                <ion-text class="checkbox-heading">Manager Evaluation</ion-text>
                <br />
                <ion-text class="checkbox-desc">I want the Manager to complete a self-evaluation.</ion-text>
              </ion-checkbox>
            </div>

            <div class="form-row">
              <ion-checkbox formControlName="holdingMeeting" labelPlacement="end" class="capitalize">
                <ion-text class="checkbox-heading">Hold Meeting</ion-text>
                <br />
                <ion-text class="checkbox-desc">
                  I want to run the Quarterly Discussion meeting using the Ninety platform.
                </ion-text>
              </ion-checkbox>
            </div>

            <div class="form-row">
              <ion-checkbox formControlName="revealAnswersPriorToMeeting" labelPlacement="end">
                <ion-text class="checkbox-heading">Reveal Answers Prior to Meeting</ion-text>
                <br />
                <ion-text class="checkbox-desc">
                  I want us both to be able to see each other’s form responses prior to our meeting.
                </ion-text>
              </ion-checkbox>
            </div>
          </div>
        </ion-accordion>
      </ion-accordion-group>
    </div>
  </form>
</ng-container>
